import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, input, model } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
    PillCellComponent,
    PillHeaderCellComponent,
    PillHeaderRowComponent,
    PillRowComponent,
    PillTableComponent
} from '../../pill-table';
import { ApplicationDetailDashboardBoxComponent } from '../application-detail-dashboard-box/application-detail-dashboard-box.component';
import { SiCalendarButtonComponent, SiDatepickerDirective } from '@siemens/element-ng/datepicker';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { DATE_ORDER_ERROR_KEY } from '../helpers/application-detail-cross-validation.helper';

@Component({
    selector: 'tran-application-detail-deadlines',
    imports: [
        ApplicationDetailDashboardBoxComponent,
        TranslateModule,
        PillTableComponent,
        PillHeaderRowComponent,
        PillRowComponent,
        PillHeaderCellComponent,
        PillCellComponent,
        SiCalendarButtonComponent,
        SiDatepickerDirective,
        DatePipe,
        ReactiveFormsModule
    ],
    templateUrl: './application-detail-deadlines.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationDetailDeadlinesComponent {
    public readonly heading = input<string>(
        'components.application-detail-dashboard.application-detail-deadlines.heading'
    );
    public readonly isLoading = model<boolean>(false);
    public readonly readonly = input<boolean>(false);
    public readonly startDate = input<string | null>();
    public readonly endDate = input<string | null>();

    public readonly startDateControl = input<FormControl<Date | null>>(new FormControl());
    public readonly endDateControl = input<FormControl<Date | null>>(new FormControl());

    protected readonly dateOrderErrorKey = DATE_ORDER_ERROR_KEY;

    constructor() {
        effect(() => this.patchValue(this.startDateControl(), this.startDate()));
        effect(() => this.patchValue(this.endDateControl(), this.endDate()));
    }

    protected patchValue(effectiveControl?: FormControl<Date | null>, value?: string | null): void {
        if (effectiveControl) {
            effectiveControl.patchValue(value ? new Date(value) : null);
        }
    }
}
